import ThongTinPhieu from '../../../tab-thuoc/components/thong-tin-phieu/ThongTinPhieu';
import { useTabVatTuContext } from '../../context';

const ThongTinPhieuVatTu = () => {
	const { donVatTuDetail, setDonVatTuDetail, setDonVatTuList } = useTabVatTuContext();

	return <ThongTinPhieu thongTinPhieu={donVatTuDetail} setThongTinPhieu={setDonVatTuDetail} setDanhSachPhieu={setDonVatTuList} />;
};

export default ThongTinPhieuVatTu;
